import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import ArrowRightSvg from "../../assets/icon/svgJsx/ArrowRightSvg";

export default function NavItem({
  navBoxIsOpen,
  isOpen,
  setIsOpen,
  breadcrumbItems,
  navItem,
}) {
  const parentItemRef = useRef(null);
  const childListRefItem = useRef(null);
  const currentMainListOfNav = breadcrumbItems?.main === navItem?.mainMenu?.title;


  useEffect(() => {
    if (!navBoxIsOpen) {
      setIsOpen(false);
    }
    if (navBoxIsOpen && currentMainListOfNav) {
      setIsOpen(true);
    }

    const handleClickOutside = (event) => {
      if (!navBoxIsOpen) {
        if (
          parentItemRef.current &&
          childListRefItem.current &&
          !parentItemRef.current.contains(event.target) &&
          !childListRefItem.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [parentItemRef, childListRefItem, navBoxIsOpen, currentMainListOfNav]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleNavLinkClick = () => {
    if (!navBoxIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <li
      className={` relative border-sky-key ${
        currentMainListOfNav && !navItem?.subMenus
          ? `bg-storm-10 ${navBoxIsOpen ? "border-l-2" : ""} `
          : "bg-storm-light"
      } ${!navBoxIsOpen && currentMainListOfNav && "!bg-sky-20 border-r-2 "}`}
    >
      {navItem?.subMenus?.length > 0 ? (
        <div
          ref={parentItemRef}
          onClick={handleToggle}
          className={`px-4 mainMenu py-3 flex items-center justify-between`}
        >
          <div className="flex items-center gap-4">
            <i>{React.createElement(navItem?.mainMenu?.icon)}</i>
            {navBoxIsOpen && (
              <span className="text-storm-key">{navItem?.mainMenu?.title}</span>
            )}
          </div>

          <i className={` ${isOpen ? " -rotate-90" : ""}`}>
            <ArrowRightSvg />
          </i>
        </div>
      ) : (
        <NavLink
          to={navItem?.mainMenu?.href}
          className={`flex px-4 py-3 items-center gap-4 `}
        >
          <i className="">{React.createElement(navItem?.mainMenu?.icon)}</i>
          {navBoxIsOpen && (
            <span
              className={`${
                currentMainListOfNav && !navItem?.subMenus
                  ? "text-sky-key"
                  : "text-storm-key"
              }`}
            >
              {navItem?.mainMenu?.title}
            </span>
          )}
        </NavLink>
      )}

      {navItem?.subMenus?.length > 0 && isOpen && (
        <div
          className={`${
            !navBoxIsOpen &&
            "absolute pt-3 pr-6 z-50 bg-storm-10 translate-x-full -right-1 top-[1px]  shadow-md shadow-storm-20"
          }`}
        >
          <ul ref={childListRefItem}>
            {!navBoxIsOpen && (
              <span className="text-storm-key pb-2 pl-4">{navItem?.mainMenu?.title}</span>
            )}

            {navItem?.subMenus?.map((link) => {
              return (
                <NavLink
                  key={link.id}
                  onClick={handleNavLinkClick}
                  to={link.href}
                  className={({ isActive }) =>
                    isActive 
                      ? ` ${
                          navBoxIsOpen ? "border-l-2" : ""
                        } bg-storm-10 px-4 py-3 border-sky-key submenu isActive flex items-center gap-4`
                      : "px-4 py-3 flex items-center submenu gap-4"
                  }
                >
                  <li className="flex items-center gap-4 pl-4">
                    <i>{React.createElement(link?.icon)}</i>
                    <span className={`text-sm text-storm-40 w-max`}>{link?.title}</span>
                  </li>
                </NavLink>
              );
            })}
          </ul>
        </div>
      )}
    </li>
  );
}
